import styled from 'styled-components';
import { Modal } from 'reactstrap';

export const StyledModal = styled(Modal)`
  max-width: 400px;

  & .modal-body,
  .modal-footer {
    padding: 0;
  }
  & .modal-content {
    top: 407px;
    height: 195px;
  }
`;

export const StyledTitle = styled.p`
  margin-bottom: 0;
  height: 44px;
`;

export const StyledBody = styled.p`
  padding: 0 24px 16px 24px;
  margin: 0;
`;

export const StyledFooter = styled.p`
  padding: 0 24px 24px;
  margin: 0;
`;
